/** @jsxImportSource @emotion/react */
import React from "react";
import { Token } from "../../../store/global/TokenEnum";
import { useStoreState } from "pullstate";
import { GlobalStore } from "../../../store/global/GlobalStore";
import { getMakerTokens } from "../../../store/global/selectors";
import "./AmountLabel.css";
import styled from "@emotion/styled";
import { Theme } from "../../../styles/theme";

export interface PercentageLabelProps {
  symbol: Token;
  visible?: boolean;
  theme: Theme;
}

export const PercentageLabel: React.FC<PercentageLabelProps> = props => {
  const pctValue =
    useStoreState(GlobalStore, getMakerTokens).find(entry => entry.token === props.symbol)?.pct ??
    1;

  const PercentageInput = styled.span`
    height: 38px;
    box-sizing: border-box;
    border-radius: 4px;
    text-align: right;
    font-weight: 500;
    color: ${props.theme.font.secondary.default};
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    margin-left: 4px;
    font-size: 20px;
  `;
  if (!props.visible) {
    return null;
  }
  return <PercentageInput data-testid="percentage-label">{pctValue}%</PercentageInput>;
};
